"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectContent_exports = {};
__export(SelectContent_exports, {
  SelectContent: () => SelectContent
});
module.exports = __toCommonJS(SelectContent_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("@floating-ui/react");
var import_core = require("@tamagui/core");
var import_dismissable = require("@tamagui/dismissable");
var import_focus_scope = require("@tamagui/focus-scope");
var import_context = require("./context");
var import_useSelectBreakpointActive = require("./useSelectBreakpointActive");
const CONTENT_NAME = "SelectContent";
const SelectContent = ({
  children,
  __scopeSelect,
  zIndex = 1e3,
  ...focusScopeProps
}) => {
  const context = (0, import_context.useSelectContext)(CONTENT_NAME, __scopeSelect);
  const themeName = (0, import_core.useThemeName)();
  const showSheet = (0, import_useSelectBreakpointActive.useShowSelectSheet)(context);
  const contents = /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.Theme, { forceClassName: true, name: themeName, children });
  const touch = (0, import_core.useIsTouchDevice)();
  if (showSheet) {
    if (!context.open) {
      return null;
    }
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_jsx_runtime.Fragment, { children: contents });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingPortal, { children: context.open ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingOverlay, { style: { zIndex }, lockScroll: !touch, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_focus_scope.FocusScope, { loop: true, trapped: true, ...focusScopeProps, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_dismissable.Dismissable, { children: contents }) }) }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { style: { display: "none" }, children: contents }) });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SelectContent
});
//# sourceMappingURL=SelectContent.js.map
